import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../Context/AppContext";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import { CategoryContext } from "./CategoryContext";
import Utils from "../../../Common/Utils";
import SkeletonElement from "./Shimmer/SkeletonElement";
import { Link, useNavigate } from "react-router";
import Search from "Components/DesignSystem/Search/Search";
import Alert from "Components/DesignSystem/Alert/Alert";
import EmptyState from "Components/DesignSystem/EmptyState/EmptyState";
import { ChevronRight } from "Components/DesignSystem/Iconography/Icons";
import { FOCUS_RING } from "Components/DesignSystem/focusRing";

let catTypeList = [];
let isSearchActive = false;

function CategoryList({ props, setApiCallDone, setCategoryDetailPageLoaded }) {
  const appData = useContext(AppContext);
  const categoryContextData = useContext(CategoryContext);
  const [loading, setLoading] = React.useState(false);
  const [categoryTypeList, setCategoryTypeList] = React.useState([]);
  const [categoryList, setCategoryList] = React.useState([]);
  let itemId = "";

  const [errorMessage, setErrorMessage] = useState(null);

  const industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;

  async function load_categoriesList(showStatus = true) {
    if (showStatus) {
      setLoading(true);
    }
    let res = await ServiceWrapper.doGet(
      api_base_url + "category/getbyindustryid/" + industryId,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      await setCategoryList(res.data.data);
      await setFilteredCategories(res.data.data);
      setLoading(false);

      if (categoryContextData.editingItem != null) {
        categoryContextData.setEditingItem((prev) => ({
          type: prev.type,
          form: prev.form,
          id: prev.id,
        }));
      }

      if (
        categoryContextData.editingItem === null &&
        props.props.match.params.uid === undefined
      ) {
        setTimeout(() => {
          try {
            let createPage = false;
            if (res.data.data.length === 0) return;
            if (catTypeList.length === 0) return;
            let resutl = res.data.data.filter((item) => {
              return item.cattype === catTypeList[0].id;
            });
            categoryContextData.setCategoryType({
              type: "c",
              id: resutl[0]?.id,
            });
            if (props.props.match.params.type === "ct") {
              createPage = true;
            }

            if (props.props.match.params.type === "c") {
              createPage = true;
            }
            if (!createPage) {
              categoryContextData.setEditingItem({
                type: "c",
                form: "view",
                id: resutl[0]?.id ?? "",
              });
            }
            setApiCallDone(true);
          } catch (e) {
            console.log(e);
          }
        }, 1000);
      }
    } else {
      setLoading(false);
      setErrorMessage("Error while fetching Categories, Please refresh again!");
    }
  }

  async function load_CategoryTypes() {
    setLoading(true);

    let res = await ServiceWrapper.doGet(
      api_base_url + "categorytype/getbyindustryid/" + industryId,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      await setCategoryTypeList(res.data.data);
      // categoryContextData.setCategoryTypeList(res.data.data);
      const sortedData = res.data.data.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
      catTypeList = sortedData;
      categoryContextData.setCategoryTypeList(sortedData);
      setFilteredCategoryList(sortedData);
      setLoading(false);
    } else {
      setLoading(false);
      setErrorMessage("Error while fetching Categories, Please refresh again!");
    }
  }

  function getCategoryList(categoryTypeId) {
    return filteredCateogories.filter((item) => {
      return item.cattype === categoryTypeId;
    });
  }

  const [filteredCateogoryList, setFilteredCategoryList] = useState(categoryTypeList);
  const [filteredCateogories, setFilteredCategories] = useState(categoryList);

  /* DS `Search` is controlled, where the legacy `<input>` was not — the value state
     is new plumbing, not new behavior. */
  const [searchValue, setSearchValue] = useState("");
  /* Explicit chevron toggles, replacing Bootstrap's collapse plugin. Only the
     sections the user has actually toggled live here; everything else falls back to
     the derived default below (search shows all, otherwise first section open) —
     the same defaults the legacy class derivation produced. Cleared on every search
     change, as the legacy re-derivation effectively did. */
  const [toggledSections, setToggledSections] = useState({});

  const isSectionOpen = (index) =>
    toggledSections[index] !== undefined
      ? toggledSections[index]
      : isSearchActive || index === 0;

  async function handleSearchAttribute(value) {
    setToggledSections({});
    if (!Utils.isEmpty(value)) {
      const searchValue = value.toString().trim().toLowerCase();
      let updatedCategoryTypes = [];
      let updatedCategories = [];
  
      // STEP 1: First check category types
      const matchingCategoryTypes = categoryTypeList.filter(type => 
        type.name?.toLowerCase().includes(searchValue)
      );
  
      // If any category types match, include ALL their categories
      if (matchingCategoryTypes.length > 0) {
        updatedCategoryTypes = matchingCategoryTypes;
        
        // Get ALL categories belonging to matching category types
        updatedCategories = categoryList.filter(category =>
          matchingCategoryTypes.some(type => type.id === category.cattype)
        );
      }
  
      // STEP 2: Then check for matching categories
      const matchingCategories = categoryList.filter(category => 
        (category.name?.toLowerCase().includes(searchValue)) ||
        (category.description?.toLowerCase().includes(searchValue))
      );
  
      if (matchingCategories.length > 0) {
        // Get parent types of matching categories
        const parentTypes = categoryTypeList.filter(type =>
          matchingCategories.some(category => category.cattype === type.id)
        );
        
        // Combine results, avoiding duplicates
        updatedCategoryTypes = [...new Set([...updatedCategoryTypes, ...parentTypes])];
        
        // Add any matching categories that weren't already included
        const additionalCategories = matchingCategories.filter(category =>
          !updatedCategories.some(existing => existing.id === category.id)
        );
        updatedCategories = [...updatedCategories, ...additionalCategories];
      }
  
      // If no matches found in either
      if (matchingCategories.length === 0 && matchingCategoryTypes.length === 0) {
        updatedCategoryTypes = [];
        updatedCategories = [];
      }
  
      // Update state
      setFilteredCategoryList(updatedCategoryTypes);
      setFilteredCategories(updatedCategories);
      isSearchActive = updatedCategories.length > 0 || updatedCategoryTypes.length > 0;
    } else {
      // Reset to original lists if search is empty
      isSearchActive = false;
      setFilteredCategoryList(categoryTypeList);
      setFilteredCategories(categoryList);
    }
  }

  const navigate = useNavigate();

  useEffect(() => {
    if (appData.pm.checkPermission("gmscategory_read")) {
      if (industryId) {
        load_CategoryTypes();
        load_categoriesList();
      }
    } else {
      navigate("/workspace/module/permission/denied");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industryId, categoryContextData.listReloadCounter]);

  const handleCategorySelect = (item1) => {
    if (categoryContextData?.categoryType?.id === item1?.id) return;
    categoryContextData.setCategoryType({
      type: "c",
      id: item1.id,
    });
    setCategoryDetailPageLoaded(false);
    categoryContextData.setEditingItem({
      type: "c",
      form: "view",
      id: item1.id,
    });

    // scroll the window to top on category change
    if (window) window.scrollTo(0, 0);
  };

  return (
    <React.Fragment>
      {loading && (
        <div className="px-3 h-100">
          <SkeletonElement type={"title"} />
          <br />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
        </div>
      )}

      {!loading && (
        <>
          <div className="top-0 left-0 h-0 px-2 pt-0 mt-0 col md:overflow-y-auto w-100 md:max-h-full scroll">
            <div className="flex-shrink-0 pb-0">
              {/* No inner px-2 (the scroll container already carries it) and no stray
                  `&nbsp;` — both were phantom whitespace that misaligned the search box
                  against the tree rows below it. */}
              <div className="p-0 pt-1">
                {categoryTypeList && categoryTypeList.length > 0 && (
                  <Search
                    id="taxonomy-search-input"
                    data-testid="category-type-search-input"
                    placeholder="Search ..."
                    ariaLabel="Search categories"
                    size="sm"
                    value={searchValue}
                    onChange={(value) => {
                      setSearchValue(value);
                      handleSearchAttribute(value);
                    }}
                    className="tw-my-2"
                  />
                )}
              </div>

              <div
                style={{
                  // maxHeight: "80vh",
                  overflow: "scroll",
                  paddingRight: "5px",
                }}
              >
                {!loading && !errorMessage && (
                  <ul className="list-unstyled">
                    {categoryTypeList && categoryTypeList.length > 0 ? (
                      filteredCateogoryList.map((item, index) => {
                        const sectionOpen = isSectionOpen(index);
                        return (
                          <div key={index} id={`taxonomy-category-type-${index}`} className="">
                            {/* The row is one hover target (§ 51.2's one-hover-ground rule),
                                and both controls in it wear the focus-visible ring — a mouse
                                click no longer strands a UA focus rectangle on the chevron. */}
                            <div className="gap-1 d-flex tw-items-center tw-rounded-ctl hover:tw-bg-surface-hover tw-transition-colors tw-py-0.5">
                              {/* A real button where Bootstrap had a mouse-only <span>:
                                  keyboard-reachable, and aria-expanded now reports what is
                                  actually visible (the legacy derivation could disagree with
                                  the plugin's DOM state). */}
                              <button
                                type="button"
                                id={`taxonomy-category-type-${index}-toggle`}
                                aria-expanded={sectionOpen}
                                aria-controls={`item-${index}`}
                                aria-label={`Toggle ${item.name}`}
                                onClick={() =>
                                  setToggledSections((prev) => ({
                                    ...prev,
                                    [index]: !sectionOpen,
                                  }))
                                }
                                className={`tw-bg-transparent tw-border-0 tw-p-0.5 tw-flex tw-items-center tw-rounded-ctl tw-text-ink-secondary hover:tw-text-ink tw-transition-colors ${FOCUS_RING}`}
                              >
                                <ChevronRight
                                  size={16}
                                  aria-hidden="true"
                                  className={`tw-transition-transform ${sectionOpen ? "tw-rotate-90" : ""}`}
                                />
                              </button>
                              <button
                                type="button"
                                data-testid={`category-categorylist-label-1-${item.id}`}
                                id={`taxonomy-category-type-${index}-label`}
                                title={item.name}
                                onClick={() => {
                                  categoryContextData.setCategoryType({
                                    type: "ct",
                                    id: item.id,
                                  });
                                  categoryContextData.setEditingItem({
                                    type: "ct",
                                    form: "view",
                                    id: item.id,
                                  });
                                }}
                                className={`tw-bg-transparent tw-border-0 tw-p-0 tw-text-left tw-truncate tw-w-4/5 tw-text-body-primary tw-text-ink tw-rounded-ctl ${FOCUS_RING}`}
                              >
                                {item.name}
                              </button>
                            </div>
                            {sectionOpen && (
                              <div id={`item-${index}`}>
                                {getCategoryList(item.id).length > 0 ? (
                                  getCategoryList(item.id).map(
                                    (item1, index1) => {
                                      if (index === 0 && index1 === 0) {
                                        if (itemId !== item1.id) {
                                          itemId = item1.id;
                                        }
                                      }
                                      const isSelected =
                                        categoryContextData.editingItem &&
                                        categoryContextData.editingItem.id ===
                                          item1.id;
                                      return (
                                        <div className="w-100" key={index1}>
                                          <li>
                                            {/* Off the global `.btn-toggle-nav a` rule — its
                                                `background: none` on hover outranked any
                                                Tailwind hover ground (cascade, not intent).
                                                Geometry preserved; the selected row wears the
                                                § 49 selection pair (accent ink on accent tint),
                                                the same grammar as the app sidebar. */}
                                            <Link
                                              id={`taxonomy-category-type-${index}-item-${index1}`}
                                              to="#"
                                              title={item1.name}
                                              onClick={() =>
                                                handleCategorySelect(item1)
                                              }
                                              className={`tw-inline-flex tw-items-center tw-ml-6 tw-mt-0.5 tw-px-2 tw-py-0.5 tw-no-underline tw-capitalize tw-rounded-ctl tw-transition-colors ${
                                                isSelected
                                                  ? "tw-bg-accent-tint"
                                                  : "hover:tw-bg-surface-hover"
                                              } ${FOCUS_RING}`}
                                            >
                                              <span
                                                className={`tw-text-sub-title-label ${
                                                  isSelected
                                                    ? "tw-text-accent"
                                                    : "tw-text-ink"
                                                }`}
                                              >
                                                {item1.name}
                                              </span>
                                            </Link>
                                          </li>
                                        </div>
                                      );
                                    }
                                  )
                                ) : (
                                  <div id={`taxonomy-category-type-${index}-no-categories`} className="d-flex justify-content-center">
                                    <EmptyState size="sm" title="No categories found" />
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <EmptyState size="sm" title="No categories found" />
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {!loading && errorMessage && (
        <Alert tone="danger" live className="tw-m-2" data-testid="category-list-error-alert">
          {errorMessage}
        </Alert>
      )}
    </React.Fragment>
  );
}

export default CategoryList;
